// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconEdit = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 25 25', fill: 'none', ...props },
    <path
      d="M22.715 1.281c-.83-.82-1.95-1.31-3.13-1.28-1.16.01-2.3.49-3.1 1.31l-14.5 14.5v.01c-.08.09-.14.19-.17.3 0 .01-.02.02-.02.04l-1.77 6.91c-.07.26.01.53.2.72.14.14.33.22.53.22.06 0 .12-.01.19-.02l6.91-1.77c.02 0 .03-.02.05-.03.1-.03.19-.08.28-.16.01-.01.02-.01.02-.01l14.49-14.49c.83-.81 1.31-1.95 1.32-3.11-.02-1.18-.48-2.32-1.3-3.14zm-15.06 19.13l-4.08-4.07 13.02-13.02 4.07 4.07-13.01 13.02zm-4.74-2.61l3.28 3.28-4.41 1.13 1.13-4.41zm18.81-11.48l-4.05-4.05c.52-.48 1.21-.76 1.93-.77.73.01 1.52.3 2.06.84s.85 1.29.84 2.06c-.02.7-.3 1.39-.78 1.92z"
      fill="currentColor"
    />
  );
export default SvgIconEdit;
